module.exports = __webpack_public_path__ + "media/images/users/5-e32ecc3075d7ebcdf67510f17ba0f1fc.jpg";